import 'factory/showXML';
import 'factory/consts';

angular.module('TInv.loadPDF', [
    'ui.bootstrap',
    'TInv.util',
    'TInv.showXML',
    'TInv.consts',
]).factory('loadPDF', function ($log, $rootScope, $uibModal, $uibModalStack, revision, FileUtil) {
    return function (multiple, client, login, ok) {
        function order(a, b) {
            if (a.name != b.name)
                return (a.name > b.name) ? 1 : -1;
        }
        $uibModal.open({
            templateUrl: 'template/uploadPDF.html?rev=' + revision,
            scope: $rootScope.$new(true), // create isolated scope
            controller: function ($scope, $uibModalInstance) {
                var reAType = /[/]pdf$/i,
                    reAName = /[.]pdf$/i;
                $scope.files = [];

                $scope.multi = multiple;
                $scope.dis = false;
                $scope.insert = true;
                if (!$scope.multi)
                    $scope.message = 'It is possible to upload only a PDF at a time.';
                else
                    $scope.message = 'You can upload one or more PDFs.';
                $scope.status = [];
                function fileAddArray(fa) {
                    fa.forEach(function (element) {
                        if (!reAType.test(element.type) && !reAName.test(element.name)) {
                            $scope.status.push('This file is not in PDF format: ' + element.name);
                            $log.info('Ignored:', element.name);
                            $scope.$applyAsync(); // async because we could be called a few times in a row
                            return;
                        }
                        $log.info('File PDF:', element.name);
                    });
                    
                    fa.forEach(function (element) {
                        $scope.void = false;
                        $scope.allow = true;
                        if (reAType.test(element.type) && reAName.test(element.name)) {
                            //var valid_pdf = /^data:application\/pdf;base64,(JVBERi0.*)/; // decoded content starts with '%PDF-'
                            $log.debug('Reading file PDF.');
                            FileUtil.readAsBuffer(element
                            ).then(function (content) {
                                var clean_filename = element.name.replace(/[^a-z0-9._-]/gi,'');
                                if($scope.multi || $scope.status.length == 0){
                                    $scope.status.push('PDF loaded correctly: ' + clean_filename);
                                    $scope.dis = true;
                                    $scope.allow = true;
                                    $scope.insert = false;
                                }
                                $log.debug('Adding file...');
                                if($scope.files.length == 0 || $scope.multi){
                                    if($scope.allow){
                                        $scope.files.push({
                                            name: clean_filename,
                                            type: element.type,
                                            size: element.size,
                                            content: content
                                        });
                                    }
                                }
                                $scope.files.sort(order);
                                // $log.debug('Files array:');
                                // [].forEach.call($scope.files, function (i) {
                                //     $log.debug(i.name);
                                //     $log.debug(i.type);
                                //     $log.debug(i.size);
                                //     $log.debug(i.content);
                                // });
                            }).catch(function (err) {
                                $scope.status.push('PDF not valid: ' + element.name);
                                $log.info('PDF not valid:', err);
                            });
                        }
                    });
                }
                $scope.fileAdd = function (files) {
                    if($scope.insert || $scope.multi){
                        files.sort(function (a, b) {
                            var na = a.name.toUpperCase(),
                                nb = b.name.toUpperCase();
                            if (na < nb) return -1;
                            if (na > nb) return +1;
                            return 0;
                        });
                        fileAddArray(files);
                    }
                };
                $scope.ok = function () {
                    ok($scope, $uibModalInstance);
                };
                $scope.remove = function (f, noLog) {
                    if (noLog !== true)
                        $scope.status.push('PDF removed: ' + f.name);
                    var idx = $scope.files.indexOf(f);
                    $scope.dis = false;
                    $scope.insert = true;
                    if (idx >= 0)
                        $scope.files.splice(idx, 1);
                };
                $scope.resetStatus = function(){
                    $scope.status = [];
                };
            }
        }).rendered.then(function(){
            $uibModalStack.getTop().value.modalDomEl.attr('id', 'modal-hidden-print');
        });
    };
});
